'use client';

import React from 'react';
import { clsx } from 'clsx';
import InputMask from '@mona-health/react-input-mask';
import { textFieldComponentType } from '@src/interfaces/components/coreUI/textField';

/**
 * Component to display TextField
 *
 * @returns Node
 */
const TextField = ({
  mask = '',
  label = '',
  endLabel = '',
  helperText = '',
  extraClasses = '',
  value = '',
  type = 'text',
  error = false,
  endAdornment = null,
  onChange,
  inputProps = {},
  inputComponent = null,
  onEndAdornmentClick,
  requiredLabel = '',
}: textFieldComponentType) => {
  // Combine classes for input
  const inputClasses = clsx(
    'block font-normal w-full px-4 py-3 text-black-dark rounded-lg border focus:ring-2 focus:border-transparent placeholder:text-black-dark/40 text-sm',
    {
      'focus:ring-blue-dark/70 border-lightertwo/50 focus:bg-blue-dark/5':
        !error,
      'border-transparent ring-2 ring-error/50 focus:ring-error/50 bg-error/5':
        error,
      'focus:ring-blue-dark/70 focus:bg-blue-dark/5 pr-12': endAdornment,
    },
    extraClasses
  );

  // Error classes conditions
  const errorFieldClasses = clsx('block text-xs my-1 font-normal', {
    'text-black': !error,
    'text-error': error,
  });

  return (
    <>
      {label ? (
        <label className="mb-2.5 text-xs text-black-lighter flex justify-between uppercase font-medium tracking-wide">
          <div className="flex">
            {label}
            {requiredLabel ? (
              <span className="text-pink-dark">{requiredLabel}</span>
            ) : null}
          </div>
          {endLabel ? <span className="text-pink-dark">{endLabel}</span> : null}
        </label>
      ) : null}
      <div className="relative w-full">
        {endAdornment ? (
          <div
            onClick={(event) => {
              if (onEndAdornmentClick) {
                onEndAdornmentClick(event);
              }
            }}
            className="absolute right-0 z-10 flex items-center cursor-pointer h-full w-12 text-secondary-dark hover:text-secondary-light hover:opacity-75"
          >
            <div className="m-auto">{endAdornment}</div>
          </div>
        ) : null}

        {mask ? (
          <InputMask
            mask={mask}
            maskPlaceholder="x"
            type={type}
            onChange={onChange}
            value={value}
            className={inputClasses}
            {...inputProps}
          />
        ) : null}

        {inputComponent ? inputComponent : null}

        {!inputComponent && !mask ? (
          <input
            type={type}
            onChange={onChange}
            value={value}
            className={inputClasses}
            {...inputProps}
          />
        ) : null}
      </div>
      {helperText ? (
        <span className={errorFieldClasses}>{helperText}</span>
      ) : null}
    </>
  );
};

export default TextField;
